<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Merchant Profile</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Merchant Profile</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div class="col-12 col-lg-6 col-sm-12">
        <router-link
          :to="redirect('add')"
          type="button"
          class="btn btn-primary mb-2 pull-right"
          >Add Banner</router-link
        >

        &nbsp;

        <!-- <router-link
          class="btn btn-primary mb-2 pull-right text-white"
          to="/qrcode"
          >QR Code</router-link
        > -->
      </div>

      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
        <div class="btn-group col-lg-6 col-sm-12 pl-0 pl-sm-3" role="group">
          <button
            class="btn btn-secondary active"
            id="btn-active"
            type="button"
            @click="active1()"
          >
            Active
          </button>
          <button
            class="btn btn-secondary"
            id="btn-pending"
            type="button"
            @click="pending1()"
          >
            Pending
          </button>
        </div>
      </div>
    </div>

    <!-- <input id="qrtext" type="hidden" v-model="qr_string" style="width:80%" /><br /> -->
    <!-- <div id="qrcode"></div> -->

    <br />

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- <p>Add new banner and company detail to be shown on Takaful Brunei Mobile App</p> -->

        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class>
              <h4 class="card-title mb-3">
                <b>Active</b>
              </h4>
              <!-- <p>The table shows the list of active items.</p> -->

              <p>
                Add new banner and company detail to be shown on Takaful Brunei
                Mobile App
              </p>

              <br />

              <!-- Active -->
              <div class="table-responsive">
                <table
                  id="active_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Banner</th>
                      <th>Description</th>
                      <!-- <th>Remarks</th> -->
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="active != null">
                      <td>1</td>
                      <td>{{ active.name }}</td>
                      <td><img height="60px" :src="active_src" /></td>
                      <td>{{ active.description }}</td>
                      <!-- <td>{{ active.remarks }}</td> -->
                      <td>
                        <router-link
                          :to="redirect('update', 'active')"
                          class="btn btn-primary btn-rounded btn-block"
                          >View Details</router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Pending -->
            <div id="pending" class="d-none">
              <h4 class="card-title mb-3">
                <b>Pending</b>
              </h4>
              <!-- <p>The table shows the pending list of pending item</p> -->

              <p>
                Add new banner and company detail to be shown on Takaful Brunei
                Mobile App
              </p>

              <div class="table-responsive">
                <table
                  id="pending_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Name</th>
                      <th>Banner</th>
                      <th>Description</th>
                      <th>Remarks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="pending != null">
                      <td>1</td>
                      <td>{{ pending.name }}</td>
                      <td><img height="60px" :src="pending_src" /></td>
                      <td>{{ pending.pending_description }}</td>
                      <td>{{ pending.remarks }}</td>
                      <td>
                        <router-link
                          :to="redirect('update', 'pending')"
                          class="btn btn-primary btn-rounded btn-block"
                          >View Details</router-link
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor-products",
  components: {},

  data() {
    return {
      active: [],
      pending: [],
      id: "",
      active_src: "",
      pending_src: "",
      qr_string: "",
      qr_status: 0
    };
  },

  methods: {
    loadVendor() {
      let token = localStorage.getItem("token");
      let user = JSON.parse(localStorage.getItem("user"));

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(axios.lpsURL + "/vendor/" + user.id, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.active = res.data.vendor[0];

            this.id = this.active.id;
            this.qr_string = this.active.qr_string;

            if (
              this.active.pending_banner_link != null ||
              this.active.pending_description != null
            ) {
              this.pending = this.active;

              this.loadPendingImage(token);
            } else {
              this.pending = null;
            }

            this.loadActiveImage(token);
          })
          .then(ok => {
            this.makeCode();
          })
          .then(function() {
            $("#active_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });

            $("#pending_tbl").DataTable({
              pageLength: 5,
              dom: "Bfrtip",
              buttons: ["excel", "pdf"]
            });
          });
      }
    },

    loadPendingImage(token) {
      axios
        .get(axios.lpsURL + "/vendor/banner/" + this.id + "/show/pending", {
          headers: {
            Authorization: "Bearer " + token
          },
          responseType: "blob"
        })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.pending_src = reader.result;
          };
        });
    },

    loadActiveImage(token) {
      axios
        .get(axios.lpsURL + "/vendor/banner/" + this.id + "/show/active", {
          headers: {
            Authorization: "Bearer " + token
          },
          responseType: "blob"
        })
        .then(response => {
          let reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.active_src = reader.result;
          };
        });
    },

    loadData() {
      this.destroyDatatable();
      this.loadVendor();
    },

    pending1() {
      $("#active").addClass("d-none");
      $("#pending").removeClass("d-none");

      $("#btn-pending").addClass("active");
      $("#btn-active").removeClass("active");
    },

    active1() {
      $("#pending").addClass("d-none");
      $("#active").removeClass("d-none");

      $("#btn-active").addClass("active");
      $("#btn-pending").removeClass("active");
    },

    destroyDatatable() {
      $("#active_tbl")
        .DataTable()
        .destroy();
      $("#pending_tbl")
        .DataTable()
        .destroy();
    },

    redirect(data, type) {
      if (data == "add") {
        return "/banner/add/" + this.id;
      }

      return "/banner/update/" + this.id + "/" + type;
    }

    // makeCode () {
    //   let qrcode = new QRCode("qrcode");

    //   if (this.qr_string == null || this.qr_string == "") {
    //     swal({
    //       icon: "warning",
    //       title: "Warning",
    //       text: "No QR String generated"
    //     })

    //     return;
    //   }

    //   qrcode.makeCode(this.qr_string);
    //   console.log("QR Generated")
    // },

    // viewCode(){
    //   if(this.qr_status == 0){
    //     this.qr_status = 1
    //     $("#qrcode").removeClass("d-none")
    //   } else{
    //     this.qr_status = 0
    //     $("#qrcode").addClass("d-none")
    //   }
    // }
  },

  mounted() {
    this.loadData();
  }
};
</script>
